(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[898],{

/***/ 87357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@mui/system/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(54695);
// EXTERNAL MODULE: ./node_modules/@mui/system/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(60916);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 4 modules
var styled_engine = __webpack_require__(27052);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx_styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js + 1 modules
var useTheme = __webpack_require__(79718);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createBox.js


const _excluded = ["className", "component"];







function createBox(options = {}) {
  const {
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName,
    styleFunctionSx = styleFunctionSx_styleFunctionSx/* default */.Z
  } = options;
  const BoxRoot = (0,styled_engine/* default */.ZP)('div')(styleFunctionSx);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = (0,useTheme/* default */.Z)(defaultTheme);

    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
          {
      className,
      component = 'div'
    } = _extendSxProp,
          other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);

    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx_m/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: theme
    }, other));
  });
   false ? 0 : void 0;
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/base/className/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(88076);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 14 modules
var createTheme = __webpack_require__(21265);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js



const defaultTheme = (0,createTheme/* default */.Z)();
/**
 * @ignore - do not document.
 */

const Box = createBox({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 66064:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-conditions",
      function () {
        return __webpack_require__(93743);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77297);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66278);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);




var Layout = function(param) {
    var children = param.children, categories = param.categories, seo = param.seo;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "auto"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                flexGrow: 1,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 93743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32283);


var TermsAndConditions = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: function() {
                    throw new Error("Sentry Frontend Error");
                },
                children: "Throw error"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "section section--big section--bg-world",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "headline",
                        children: "Şartlar ve Koşullar"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "generic-content-container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                            className: "content content--with-smaller-container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                    className: "MuiTypography-root MuiTypography-h5 MuiTypography-gutterBottom",
                                    children: "Şartlar ve koşullar"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Bu b\xf6l\xfcm işkıbrıs.com‘un genel kullanım şartlarını, genel ve yasal sorumlulukları i\xe7ermektedir. Sistemi kullanmadan \xf6nce aşağıda yazanları okumanız ve sistemi kullanmanız durumunda bu sayfalarda yazılı şartları peşinen kabul ettiğiniz anlamına gelir. Eğer bu sayfada yazılı şartları kabul etmez iseniz l\xfctfen sistemi kullanmayınız. Bu sayfada bulunan genel kullanım şartlarını işkıbrıs.com dilediği zaman değiştirme hakkına sahiptir. Siteyi ziyaret ettiğinizde bu sayfayı okumanız tavsiye edilir."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    children: "Kullanım Kuralları"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Yanlış, d\xfczensiz, eksik ve yanıltıcı bilgilerin, genel ahlak kurallarına uygun olmayan ifadeleri i\xe7eren bilgilerin siteye kaydedilmesi durumunda,"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Sitede yer alan bilgilerin kısmen veya t\xfcm\xfcyle kopyalanarak farklı ama\xe7larla kullanılması veya kullanılmaya \xe7alışılması durumunda,"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "\xdcyelere verilen kullanıcı adı, şifre gibi bilgilerin, \xfc\xe7\xfcnc\xfc kişi ve kuruluşlarla paylaşılması durumunda,"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Sitenin genel g\xfcvenliğini tehdit edecek, kullanılan yazılımların \xe7alışmasını engelleyecek yazılımların yapılması, yapılmaya \xe7alışılması durumunda,"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Vir\xfcs vasıtasıyla sitenin \xe7alışmasını engellemek,"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Siteyi kullanan diğer kullanıcı bilgilerine girmek veya girmeye \xe7alışmak."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    children: "İ\xe7erik Kopyalanması"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Bu Sitede yer alan b\xfct\xfcn yazılar, grafikler, istatistiki bilgiler ve resimler 5846 sayılı Fikir ve Sanat Eserleri Kanunu ile ilgili sair yasa ve y\xf6netmeliklerden doğan t\xfcm fikri ve sınai m\xfclkiyet hakları, m\xfcnhasıran işkıbrıs.com’a aittir. Sitede yer alan yazılar, grafikler, istatistiki bilgiler ve resimler işkıbrıs.com’un yazılı onayı olmaksızın kopyalanması, \xe7oğaltılması, yayınlanması veya yeniden yayınlanması yasaktır. Aynı şekilde Sitenin isim hakkı ve logosu m\xfcnhasıran işkıbrıs.com’a ait olup hi\xe7bir surette işkıbrıs.com’un yazılı onayı olmaksızın kullanılamaz, 3. kişi ve kuruluşların kullanımına sunulamaz. Site m\xfcnhasıran işkıbrıs.com’un kullanımında olup Sitede yer alan herhangi bir unsur diğer bir mecrada veya Internet sitesinde yayınlanamaz veya işkıbrıs.com’un izni olmadan başka bir internet sitesinden işkıbrıs.com‘a link verilemez, y\xf6nlendirme yapılamaz. Ayrıca sitenin tasarımı ve veritabanı oluşturulmasında ,aynı zamanda t\xfcm kullanıcılara sağlanan fonksiyonların hazırlanmasında kullanılan yazılımın kopyalanması veya kullanılması kesinlikle yasaktır."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    children: "Genel Sorumluluklar"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Site i\xe7erisinde daha \xf6nceden haber vermeksizin değişiklik yapma hakkı işkıbrıs.com tarafından saklı tutulmaktadır. Sitede yer alan bireysel kullanıcı ve firma bilgilerinden işkıbrıs.com sorumlu tutulamaz. Sitede Cv‘sini oluşturan adayın ilettiği her t\xfcrl\xfc bilginin tek sorumlusu adaydır. Aday bu bilgileri kendi oluşturduğunu ve her t\xfcrl\xfc bilginin doğru olduğunu kabul etmektedir. işkıbrıs.com veritabanında bulundurduğu Cv‘lerin sorumluluğunu alamaz. Sitenin \xfcyelerine iş ve/veya aday bulmak gibi bir sorumluluğu yoktur. Firmalar ve adaylar arasında oluşan her t\xfcrl\xfc ilişkiden firma ve adaylar kendileri sorumludur. işkıbrıs.com sitenin \xe7alışması amacıyla kullandığı yazılımlarla ilgili sorumluluk almamaktadır. Sitede yer alan herhangi bir yazılım sebebi ile kullandığınız yazılım ve donanım unsurlarına herhangi bir zarar gelmesinden dolayıişkıbrıs.com‘a bu konu ile ilgili bir sorumluluk y\xfcklenemez. işkıbrıs.com, sitenin yazılımının her t\xfcrl\xfc hatadan arınmış olduğunu ve sitede herhangi bir vir\xfcs yer alıp almadığı ile ilgili bir sorumluluk y\xfcklenmemektedir. işkıbrıs.com bu sitede yer alan her t\xfcrl\xfc bilgi, haber, makale ve diğer materyal ile ilgili herhangi bir sorumluluk kabul etmez. işkıbrıs.com gizlilik prensiplerine sadık kalarak bazı pazarlama faaliyetlerinde \xfcye bilgilerini reklam, tanıtım ve pazarlama amacıyla kullanabilir. işkıbrıs.com reklam, tanıtım ve pazarlama ama\xe7lı e-posta ve sms g\xf6nderimi yapabilir. Bu sitede paylaştığınız bilgilerin işkıbrıs.com tarafından \xdcYE FİRMALAR HARİCİNDE \xfc\xe7\xfcnc\xfc kişilerle paylaşılmasını; Site kapsamında işverenler ile adaylar arasında yapılabilecek online g\xf6r\xfcşmelerde tarafların g\xfcvenliği i\xe7in ses ve g\xf6r\xfcnt\xfc kaydı alınacaktır. işkıbrıs.com’un ilgili kayıtlar ile ilgili cezai veya hukuki hi\xe7bir sorumluluğu bulunmamaktadır. işkıbrıs.com‘a g\xf6sterdiğiniz ilgi ve g\xfcven nedeni ile teşekk\xfcr ederiz."
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (TermsAndConditions);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [160,795,774,888,179], function() { return __webpack_exec__(66064); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);